/**
 * 案件マスタ：作業カテゴリ
 */
import { isBlank } from '@/utilities/typing';

class Category {
    category_id;
    taxonomy;
    category_name;

    constructor(properties) {
        if (isBlank(properties)) {
            properties = {};
        }

        this.category_id = properties.category_id;
        this.taxonomy = properties.taxonomy;
        this.category_name = properties.category_name;
    }
}

export default Category;
